var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyActionBar } from "./components/action-bar/action-bar";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { LoadingIndicatorComponent } from "./components/loading-indicator";
import { SurveyAction } from "./components/action-bar/action-bar-item";
import { ReactElementFactory } from "./element-factory";
var SurveyQuestionFile = /** @class */ (function (_super) {
    __extends(SurveyQuestionFile, _super);
    function SurveyQuestionFile(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionFile.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionFile.prototype.renderElement = function () {
        var _this = this;
        var preview = this.question.allowShowPreview ? this.renderPreview() : null;
        var loadingIndicator = this.question.showLoadingIndicator ? this.renderLoadingIndicator() : null;
        var video = this.question.isPlayingVideo ? this.renderVideo() : null;
        var fileDecorator = this.question.showFileDecorator ? this.renderFileDecorator() : null;
        var fileNavigator = this.question.fileNavigatorVisible ? (React.createElement(SurveyActionBar, { model: this.question.fileNavigator })) : null;
        var acceptedTypes = this.question.renderedAcceptedTypes;
        var className = !this.isDisplayMode ? this.question.cssClasses.fileInput : this.question.getReadOnlyFileCss();
        var style = this.isDisplayMode ? { color: "transparent" } : {};
        var fileInput;
        if (this.question.isReadOnlyAttr) {
            fileInput = React.createElement("input", { readOnly: true, type: "file", className: className, id: this.question.inputId, ref: function (input) { return (_this.setControl(input)); }, style: style, multiple: this.question.allowMultiple, placeholder: this.question.title, accept: acceptedTypes });
        }
        else if (this.question.isDisabledAttr) {
            fileInput = React.createElement("input", { disabled: true, type: "file", className: className, id: this.question.inputId, ref: function (input) { return (_this.setControl(input)); }, style: style, multiple: this.question.allowMultiple, placeholder: this.question.title, accept: acceptedTypes });
        }
        else if (this.question.hasFileUI) {
            fileInput = React.createElement("input", { type: "file", disabled: this.isDisplayMode, tabIndex: -1, className: className, id: this.question.inputId, ref: function (input) { return (_this.setControl(input)); }, style: style, "aria-required": this.question.ariaRequired, "aria-label": this.question.ariaLabel, "aria-invalid": this.question.ariaInvalid, "aria-errormessage": this.question.ariaErrormessage, multiple: this.question.allowMultiple, title: this.question.inputTitle, accept: acceptedTypes, capture: this.question.renderCapture });
        }
        else {
            fileInput = null;
        }
        return (React.createElement("div", { className: this.question.fileRootCss, ref: function (el) { return (_this.setContent(el)); } },
            fileInput,
            React.createElement("div", { className: this.question.cssClasses.dragArea, onDrop: this.question.onDrop, onDragOver: this.question.onDragOver, onDragLeave: this.question.onDragLeave, onDragEnter: this.question.onDragEnter },
                fileDecorator,
                loadingIndicator,
                video,
                preview,
                fileNavigator)));
    };
    SurveyQuestionFile.prototype.renderFileDecorator = function () {
        var actionsContainer = this.question.actionsContainerVisible ? React.createElement(SurveyActionBar, { model: this.question.actionsContainer }) : null;
        return (React.createElement("div", { className: this.question.getFileDecoratorCss() },
            this.question.showDragAreaPlaceholder ? React.createElement("span", { className: this.question.cssClasses.dragAreaPlaceholder }, this.renderLocString(this.question.locRenderedPlaceholder)) : false,
            React.createElement("div", { className: this.question.cssClasses.wrapper }, actionsContainer)));
    };
    SurveyQuestionFile.prototype.renderPreview = function () {
        return ReactElementFactory.Instance.createElement("sv-file-preview", { question: this.question });
    };
    SurveyQuestionFile.prototype.renderLoadingIndicator = function () {
        return React.createElement("div", { className: this.question.cssClasses.loadingIndicator },
            React.createElement(LoadingIndicatorComponent, null));
    };
    SurveyQuestionFile.prototype.renderVideo = function () {
        return (React.createElement("div", { className: this.question.cssClasses.videoContainer },
            React.createElement(SurveyAction, { item: this.question.changeCameraAction }),
            React.createElement(SurveyAction, { item: this.question.closeCameraAction }),
            React.createElement("video", { autoPlay: true, playsInline: true, id: this.question.videoId, className: this.question.cssClasses.video }),
            React.createElement(SurveyAction, { item: this.question.takePictureAction })));
    };
    return SurveyQuestionFile;
}(SurveyQuestionElementBase));
export { SurveyQuestionFile };
ReactQuestionFactory.Instance.registerQuestion("file", function (props) {
    return React.createElement(SurveyQuestionFile, props);
});
